export default {"src":"https://images-cdn.curipod.com/d-09a63bb9/_next/static/media/gwinnett_county.1b5c2fe8.svg","height":86,"width":267};